<template>
  <!-- Cabeza -->
  <section id="logInSection">
    <div class="m-0 p-0 gradient-background__noise d-flex flex-column" style="min-height: 100vh; height: 100%;">
      <div class="d-flex col-lg-12 col-md-12 col-11 text-start p-3 flex-column flex-sm-row">
        <div class="col-sm-2 d-flex align-items-center justify-content-center">
          <img title="Logo" src="@/assets/img/logo.png" class="img-fluid m-auto"
            style="max-width: 250px; filter: brightness(0) invert(1);">
        </div>
        <div id="topMenu"
          class="border-bottom col-sm-10 d-flex align-items-center justify-content-sm-end justify-content-center p-3"
          style="border-color: #d8d8d8; border-bottom-width: 3px;">

          <div class="d-flex align-items-center language">
            <a href="https://www.innovative-systems.es/" class="c-pointer">
              <img title="D&A innovative-systems" src="@/assets/img/clomos.png" class="img-fluid m-auto mt-2 c-pointer"
                style="max-width: 150px;">
            </a>
            <ion-icon name="help-circle-outline" class="tx-26 tx-white" @click="toggleDropdown"></ion-icon>
            <span class="text-start text-white tx-25 text-uppercase p-1 " @click="toggleDropdown">
              {{ dictionary['Ayuda'][session.user.language] }}
            </span>
          </div>
          <div class="position-relative">


            <ul v-if="showDropdown" class="dropdown-menu dropdown-menu-start show position-absolute"
              style="left: -90px; top: 13px;">

              <li>
                <a class="dropdown-item d-flex align-items-center" @click="openWebLink('web')" target="_blank">
                  <ion-icon id="home" name="laptop-outline" class="tx-18 pe-1 tx-black"></ion-icon>
                  Web
                </a>
              </li>
              <li>
                <a class="dropdown-item d-flex align-items-center" @click="openWebLink('locker')" target="_blank">
                  <ion-icon id="home" name="file-tray-stacked-outline" class="tx-18 pe-1 tx-black"></ion-icon>
                  {{ dictionary['Locker'][session.user.language] }}
                </a>
              </li>
            </ul>
          </div>
          <div v-for="(language, index) in languages" :key="index">
            <span @click="toggleLanguage(language)" class="text-end text-white tx-25 text-uppercase p-1 language">{{
              language }}</span>
          </div>
        </div>
      </div>

      <div class="row m-0 p-0">
        <div id="ocultar"
          class="row col-lg-8 col-md-12 col-12 m-0 p-3 pt-0 pb-0 pt-0 text-white justify-content-center align-items-center">
          <div class="box justify-content-center align-items-center  m-0 p-0">
            <div class="row justify-content-center align-items-center m-0 p-0">

              <img title="Locker" src="@/assets/img/aviles_ok.jpg" class="img-fluid m-auto"
                style="max-height: 700px; max-width: 700px;">
            </div>
          </div>
        </div>

        <div class="col-lg-3 col-md-12 col-12 m-0 p-3 pt-0">
          <div class="login-box border-1 border-white box sombra-izq rounded-5">
            <div class="card-body pt-2 p-3 rounded-5 bg-menu">
              <!-- Language -->
              <div class="col-md-12">
                <div class="ms-auto me-auto mt-3 form-group text-center rounded-5">
                  <h5 class="text-white text-decoration-underline">ACCESO USUARIOS</h5>
                </div>
              </div>
              <!-- FORM Iniciar Sesion -->
              <form v-if="visibility.formLogIn" id="formLogIn" class="form-horizontal text-center">

                <div class="form-group p-3 pt-0 mt-0">
                  <span class="tx-14 tx-white">{{ errorMsg }}</span><br>
                  <div class="col-xs-10">
                    <input v-model="formLogIn.userId" id="userId" type="text" autofocus
                      class="p-2 input-white form-control"
                      :placeholder="dictionary['Nombre de usuario'][session.user.language] + '/' + dictionary['E-mail'][session.user.language]">
                  </div>
                </div>

                <div class="form-group p-3 pt-0">
                  <div class="col-xs-10">
                    <input v-model="formLogIn.password" id="password" type="password" autocomplete="off"
                      class="p-2 input-white form-control" @keydown.enter="onLogInRequest"
                      :placeholder="dictionary['Contraseña'][session.user.language]">
                  </div>
                </div>

                <input v-model="formLogIn.rememberMe" @click="formLogIn.rememberMe = !formLogIn.rememberMe"
                  id="rememberMe" type="checkbox">
                <label for="rememberMe" class="ps-1 text-white">{{ dictionary['Recuérdame'][session.user.language]
                }}</label>
                <div class="form-group text-center mt-3">
                  <div class="col-xs-12 justify-content-center d-flex">
                    <button id="btnLogin" @click="onLogInRequest" type="button"
                      class="button-ok gradient-tablas mt-1 rounded-5">
                      <span>
                        <span class="highlight-bg"></span>
                        <span class="button-text">
                          {{ dictionary["Iniciar sesión"][session.user.language] }}
                        </span>
                      </span>
                    </button>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-md-12">
                    <div class="row align-items-center">
                      <div class="ps-0 pt-3">
                        <a @click="toggleRecoveryForm" id="to-recover" class="tx-white">
                          <ion-icon name="lock-open" class="menu-item-icon tx-14"></ion-icon>
                          {{ dictionary["¿Has olvidado tu contraseña?"][session.user.language] }}
                        </a>
                      </div>
                      <div class="ps-0 pt-3">
                        <a @click="toggleValidateClientForm" id="to-validate" class="tx-white">
                          <ion-icon name="checkmark-circle" class="menu-item-icon tx-14"></ion-icon>
                          {{ dictionary["Validar cuenta"][session.user.language] }}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>

              </form>
              <!-- FORM Recuperar password -->
              <form v-if="visibility.formPasswordLost" id="formPasswordLost" class="form-horizontal">
                <div class="form-group ">
                  <div class="col-xs-12">
                    <h3 class="tx-white tx-14 mt-3">
                      {{ dictionary["Recuperar contraseña"][session.user.language] }}
                    </h3>
                    <p class="tx-white tx-13">
                      {{ dictionary["Introduce un correo electrónico al que enviar instrucciones."][session.user.language]}}
                    </p>
                       <p v-if="errorPasswordRecovery" class="tx-white tx-16 tx-bold">
                      ⚠️ {{dictionary[errorPasswordRecovery][session.user.language]}}
                    </p>
                    <p v-if="successPasswordRecovery" class="tx-white tx-16 tx-bold">
                      ✅ {{dictionary[successPasswordRecovery][session.user.language]}}
                    </p>
                    <div v-if="successPasswordRecovery" class="progress-bar-wrapper mb-4">
                    <div class="progress-bar-fill"></div>
                  </div>  
                  </div>
                </div>
                <div class="form-group ">
                  <div class="col-md-12 p-3 pt-0">
                    <input v-model="formPasswordLost.email" placeholder="Email" id="inputPasswordLost"
                      class="p-2 input-white form-control" type="text" required>
                  </div>
                </div>
                <div class="form-group text-center m-t-20">
                  <div class="col-md-12 col-12 justify-content-center d-flex">
                    <button id="btnRePass" class="button-ok gradient-tablas mt-1 rounded-5" type="button"
                      @click="onPasswordLost">
                      <p class="button-text tx-16 pt-2 mt-1">{{ dictionary["Recuperar contraseña"][session.user.language]}}</p>
                    </button>
                  </div>
                  <div class="col-md-12 justify-content-center d-flex mt-3">
                    <button id="btnBackToLogIn" @click="toggleRecoveryForm"
                      class="button-ok gradient-tablas mt-1 rounded-5" type="button">
                      <p class="button-text tx-16 pt-2 mt-1">{{ dictionary["Volver"][session.user.language] }}</p>
                    </button>
                  </div>
                </div>
              </form>
              <!-- FORM Validar email -->
              <form v-if="visibility.formValidateClient" id="formValidateClient" class="form-horizontal">
                <div class="form-group ">
                  <div class="col-md-12 col-12 justify-content-center">
                    <h3 class="tx-white tx-14 mt-3">
                      {{ dictionary["Validar cuenta"][session.user.language] }}
                    </h3>
                  </div>
                </div>
                <div class="form-group ">
                  <div class="mb-2 col-md-12">
                    <p class="tx-white tx-13 mt-3">
                      {{ dictionary["Completa el siguiente formulario para proceder con tu validación como usuario."][session.user.language]}}
                    </p>
                    <p v-if="errorValidate" class="tx-white tx-16 tx-bold">
                      ⚠️   {{dictionary[errorValidate][session.user.language]}}
                    </p>
                    <p v-if="successValidate" class="tx-white tx-16 tx-bold">
                      ✅   {{dictionary[successValidate][session.user.language]}}
                    </p>
                    <div v-if="successValidate" class="progress-bar-wrapper">
                    <div class="progress-bar-fill"></div>
                  </div>
                  </div>
                </div>
                <div class="mt-2 p-3">
                  <div class="form-label-group p-1">
                    <input v-model="formValidateClient.token" :placeholder="dictionary['Token'][session.user.language]"
                      id="inputToken" type="text" class="p-2 input-white form-control mb-3">
                    <label for="inputToken"></label>
                  </div>
                  <div class="form-label-group p-1">
                    <input v-model="formValidateClient.password"
                      :placeholder="dictionary['Contraseña'][session.user.language]" id="tokenPass" type="password"
                      class="p-2 input-white form-control mb-3" required>
                    <label for="tokenPass"></label>
                  </div>
                  <div class="form-label-group">
                    <input v-model="formValidateClient.passwordRe"
                      :placeholder="dictionary['Repite la contraseña'][session.user.language]" id="tokenRePass"
                      type="password" class="p-2 input-white form-control mb-3" required>
                    <label for="tokenRePass"></label>
                  </div>
                  <div class="col-md-12 col-12 justify-content-center d-flex mt-2">
                    <button id="btnValidarCuenta" class="button-ok gradient-tablas mt-1 rounded-5" type="button"
                      @click="onValidateAccount">
                      <p class="button-text tx-16 pt-2 mt-1"> {{ dictionary["Validar cuenta"][session.user.language] }}
                      </p>
                    </button>
                  </div>
                  <div class="col-md-12 col-12 justify-content-center d-flex mt-3">
                    <button id="btnBackToLogIn" @click="toggleValidateClientForm" type="button"
                      class="button-ok gradient-tablas mt-1 rounded-5">
                      <p class="button-text tx-16 pt-2 mt-1">{{ dictionary["Volver"][session.user.language] }}</p>
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div class="login-box border-1 border-white box sombra-izq rounded-5 mt-2">
            <div class="card-body pt-2 p-3 rounded-5 bg-menu">
              <div class="col-md-12">
                <div class="ms-auto me-auto mt-3 form-group text-center rounded-5">
                  <h5 class="text-white text-decoration-underline">{{ dictionary["Crear nuevo usuario"][session.user.language] }}</h5>
                </div>
              </div>
              <div class="col-xs-12 justify-content-center d-flex mb-3">
                <button id="btnLogin" @click="goToNewUser()" type="button"
                  class="button-ok gradient-tablas mt-1 rounded-5">
                  <span>
                    <span class="highlight-bg"></span>
                    <span class="button-text">
                      {{ dictionary["Darse de alta"][session.user.language] }}
                    </span>
                  </span>
                </button>
              </div>
            </div>
          </div>
          <div class="login-box border-1 border-white box sombra-izq rounded-5 mt-2">
            <div class="card-body pt-2 p-3 rounded-5 bg-menu">
              <div class="col-md-12">
                <div class="ms-auto me-auto mt-3 form-group text-center rounded-5">
                  <h5 class="text-white text-decoration-underline">{{ dictionary["Seguimiento de pedido"][session.user.language] }}</h5>
                </div>
              </div>
              <div class="col-xs-12 justify-content-center d-flex mb-3">
                <button id="btnLogin" @click="goToTracking()" type="button"
                  class="button-ok gradient-tablas mt-1 rounded-5">
                  <span>
                    <span class="highlight-bg"></span>
                    <span class="button-text">
                      {{ dictionary["Buscar pedido"][session.user.language] }}
                    </span>
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>


      </div>

      <!-- Pié -->
      <div class="row mt-5 pt-4 border-top border-black justify-content-around bg-light mx-0">
        <div class="col-lg-3 col-12">
          <div class="mb-2">
            <img src="@/assets/img/logo-next-generation.png" title="Logo Next Generation EU"
              alt="Logo Next Generation EU" loading="lazy" class="img-fluid">
          </div>
        </div>
        <div class="col-lg-3 col-12">
          <div class="mb-2">
            <img src="@/assets/img/logo-mece-footer.png" title="logo-mece-footer" alt="logo-mece-footer" loading="lazy"
              class="img-fluid">
          </div>
        </div>
        <div class="col-lg-3 col-12">
          <div class="mb-2">
            <img src="@/assets/img/logo-PRTR.png" title="Logo Plan de Recuperación, Transformación y Resiliencia"
              alt="Logo Plan de Recuperación, Transformación y Resiliencia" loading="lazy" class="img-fluid">
          </div>
        </div>
        <div class="col-lg-3 col-12">
          <div class="mb-2">
            <img src="https://aviles.es/image/layout_set_logo?img_id=40130&t=1739712231518"
              title="logo Diputación Foral de Alava" alt="logo Diputación Foral de Alava" loading="lazy"
              class="img-fluid">
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
// Clomos
import api from '@/services/api';

export default {
  name: "LogInView",
  props: {
    session: {
      type: Object,
      required: true,
    },
    dictionary: {
      type: Object,
      required: true,
    },
    validationToken: {
      type: String,
      required: true,
    }
  },
  data() {
    return {
      showDropdown: false,
      languages: ["es", "en"],
      errorMsg: "",
      errorValidate:"",
      successValidate:"",
      errorPasswordRecovery:"",
      successPasswordRecovery:"",
      formLogIn: {
        userId: localStorage.getItem("ClomosUserId") || "",
        password: "",
        rememberMe: localStorage.getItem("ClomosRememberMe") || true,
      },
      formPasswordLost: {
        email: "",
      },
      formValidateClient: {
        token: "",
        password: "",
        passwordRe: "",
      },
      visibility: {
        formLogIn: true,
        formPasswordLost: false,
        formValidateClient: false,
      }
    }
  },
  emits: ["logInRequest", "toggleLanguage"],
  methods: {
    openWebLink(mode) {
      let url;
      if (mode === "locker") {
        url = '/app/pantalla_es.html'
      } else {
        url = '/app/web_es.html'
      }
      window.open(url, '_blank');
      this.showDropdown = !this.showDropdown;
    },
    toggleDropdown() {
      this.showDropdown = !this.showDropdown;
    },
    goToTracking() {
      this.$router.push('/tracking');
    },
    goToNewUser() {
      this.$router.push('/' + this.session.user.language + '/altausuario');
    },
    // DISPLAY
    toggleLanguage(event) {

      if (event.target) {

        this.$emit('toggleLanguage', event.target.value);
      } else {

        this.$emit('toggleLanguage', event);
      }
    },
    toggleRecoveryForm() {
      if (this.visibility.formPasswordLost) {
        this.visibility.formPasswordLost = false;
        this.visibility.formValidateClient = false;
        this.visibility.formLogIn = true;
        this.successPasswordRecovery = "";
        this.errorPasswordRecovery = "";
      }
      else {
        this.visibility.formPasswordLost = true;
        this.visibility.formValidateClient = false;
        this.visibility.formLogIn = false;
      }
    },
    toggleValidateClientForm() {
      if (this.visibility.formValidateClient) {
        this.visibility.formPasswordLost = false;
        this.visibility.formValidateClient = false;
        this.visibility.formLogIn = true;
        this.successValidate = "";
        this.errorValidate = "";
      }
      else {
        this.visibility.formValidateClient = true;
        this.visibility.formPasswordLost = false;
        this.visibility.formLogIn = false;
      }
    },
    // GET
    onLogInRequest() {
      this.$emit('logInRequest', this.formLogIn, (response) => {
        if (response["status-code"] == undefined) {
          this.formLogIn.password = "";
          this.errorMsg = "Error de conexión.";
        }
        else if (response.session.user != undefined) {
          let path = "/" + response.session.user.language + '/' + response.session.user.nifCif + '/smartLockers/lockings/';
          this.$router.replace({ path: path });
        }
        else if (response["status-code"] === "401") {
          this.formLogIn.password = "";
          this.errorMsg = "Credenciales incorrectas."
        }
        else if (response["status-code"] === "500") {
          this.formLogIn.password = "";
          this.errorMsg = "Error en el servidor.";
        }
        else {
          this.formLogIn.password = "";
          this.errorMsg = "Límite de tiempo agotado.";
        }
        clearTimeout(this.errorMsgTimeout);
        this.errorMsgTimeout = setTimeout(() => {
          this.errorMsg = "";
        }, 5000)
      });
    },
    // SET
    async onValidateAccount() {
      if (this.formValidateClient.password != this.formValidateClient.passwordRe) {
        this.errorValidate = "Las contraseñas no coinciden";
        return;
      }
      let response = await api.validateAccount(this.formValidateClient);
      if (response) {
        this.successValidate = "Operación realizada con éxito";
        setTimeout(() => {
          this.successValidate = "";
          this.visibility.formPasswordLost = false;
          this.visibility.formValidateClient = false;
          this.visibility.formLogIn = true;
          this.formValidateClient.token = "";
          this.formValidateClient.password = "";
          this.formValidateClient.passwordRe = "";
        }, 3000);

      }
      else {
        this.errorValidate = "Operación no realizada";
        this.formValidateClient.password = "";
        this.formValidateClient.passwordRe = "";
      }
    },
    async onPasswordLost() {
      let response = await api.passwordLost(this.formPasswordLost.email);
      if (response) {
        this.successPasswordRecovery = "Operación realizada, revisa tu correo electrónico";
        setTimeout(() => {
          this.visibility.formPasswordLost = false;
          this.visibility.formValidateClient = false;
          this.visibility.formLogIn = true;
          this.formPasswordLost.email = "";
          this.successPasswordRecovery = "";
        }, 3000);
      } else {
        this.errorPasswordRecovery = "Operación no realizada";
        this.formPasswordLost.email = "";
      }
    },
  },
  created() {
    if (this.validationToken != "") {
      this.formValidateClient.token = this.validationToken;
      this.toggleValidateClientForm();
    }

  }
}
</script>
<style>
.language {
  cursor: pointer;
}

.top-menu-logo {
  background-image: url("@/assets/img/clomos.png");
  background-repeat: no-repeat;
  background-size: contain;
  background-position-y: center;
  cursor: pointer;
  width: 13rem;
  min-width: 17rem;
  height: 70%;
  padding: 0;
  margin: auto 1rem auto 1rem;
  transition: all 0.3s;
  filter: brightness(0) invert(1);
}


@media (max-width: 1000px) {
  #topMenu {
    border-bottom: none !important;
  }
}
</style>
